var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("FormGroup", {
    attrs: {
      "error-container": _vm.errorContainer,
      flex: _vm.flex,
      name: _vm.name,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ id }) {
            return [
              _c(
                "label",
                {
                  ref: "checkBox",
                  staticClass: "fm-checkbox",
                  class: {
                    "fm-checkbox--checked": _vm.proxyValue,
                    "fm-checkbox--disabled": _vm.disabled,
                  },
                  attrs: { tabindex: "0" },
                  on: {
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        $event.preventDefault()
                        return _vm.toggleValue.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _vm.toggleValue.apply(null, arguments)
                      },
                    ],
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.proxyValue,
                        expression: "proxyValue",
                      },
                    ],
                    ref: "input",
                    staticClass: "fm-checkbox__input",
                    attrs: {
                      id: id,
                      disabled: _vm.disabled,
                      type: "checkbox",
                      tabindex: "-1",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.proxyValue)
                        ? _vm._i(_vm.proxyValue, null) > -1
                        : _vm.proxyValue,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.proxyValue,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.proxyValue = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.proxyValue = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.proxyValue = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "fm-checkbox__box",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _vm.proxyValue
                        ? _c(
                            "svg",
                            {
                              attrs: {
                                viewBox: "0 0 12 12",
                                fill: "currentColor",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10.28 2.28a1 1 0 0 0-1.415 0L4.5 6.647 3.135 5.282a1 1 0 1 0-1.415 1.414l2.073 2.073a1 1 0 0 0 1.414 0l5.073-5.073a1 1 0 0 0 0-1.414z",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "fm-checkbox__content" },
                    [
                      _vm._t(
                        "default",
                        function () {
                          return [
                            _c("span", {
                              domProps: { textContent: _vm._s(_vm.label) },
                            }),
                          ]
                        },
                        null,
                        { onClick: _vm.toggleValue, style: {} }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }